// frontend/src/api/fishSpecies.ts

import { api } from './client';
import type { FishSpeciesSearchResponse, FishSpeciesDetail, FishCategoriesResponse, FishViewerResponse, FishViewerFilters, FishCanonicalWithSources, UnmergeRequest, UnmergeResponse, ManualMergeRequest, ManualMergeResponse } from '@/types/livestock';

export const fishSpeciesApi = {
  async search(query: string, limit: number = 8, category?: string): Promise<FishSpeciesSearchResponse> {
    const params = new URLSearchParams({ q: query, limit: limit.toString() });
    if (category) {
      params.append('category', category);
    }
    return api.get<FishSpeciesSearchResponse>(`/api/fish-species/search?${params}`);
  },

  async getCategories(): Promise<FishCategoriesResponse> {
    return api.get<FishCategoriesResponse>('/api/fish-species/categories');
  },

  async get(speciesId: number): Promise<FishSpeciesDetail> {
    return api.get<FishSpeciesDetail>(`/api/fish-species/${speciesId}`);
  },

  async getViewerData(filters?: FishViewerFilters): Promise<FishViewerResponse> {
    const params = new URLSearchParams();
    if (filters?.q) params.append('q', filters.q);
    if (filters?.category) params.append('category', filters.category);
    if (filters?.limit) params.append('limit', filters.limit.toString());
    if (filters?.offset) params.append('offset', filters.offset.toString());
    if (filters?.unmerged_only) params.append('unmerged_only', 'true');
    const queryString = params.toString();
    return api.get<FishViewerResponse>(`/api/fish-species/viewer${queryString ? `?${queryString}` : ''}`);
  },

  async getCanonicalWithSources(canonicalId: number): Promise<FishCanonicalWithSources> {
    return api.get<FishCanonicalWithSources>(`/api/fish-species/canonical/${canonicalId}/sources`);
  },

  async unmergeSource(request: UnmergeRequest): Promise<UnmergeResponse> {
    return api.post<UnmergeResponse>('/api/fish-species/unmerge', request);
  },

  async manualMerge(request: ManualMergeRequest): Promise<ManualMergeResponse> {
    return api.post<ManualMergeResponse>('/api/fish-species/merge', request);
  },
};
